import PropTypes from 'prop-types';

export const itemPremiacaoPropType = PropTypes.shape({
  categoria: PropTypes.string.isRequired,
  icone: PropTypes.string,
  vencedor: PropTypes.string.isRequired,
  foto: PropTypes.string
});

export const regiaoPremiacaoPropType = PropTypes.shape({
  nome: PropTypes.string.isRequired,
  colocados: PropTypes.arrayOf(
    PropTypes.shape({
      posicao: PropTypes.number.isRequired,
      vencedor: PropTypes.string.isRequired,
      foto: PropTypes.string
    })
  ).isRequired
});

export const historicoAnoPropType = PropTypes.shape({
  regioes: PropTypes.arrayOf(regiaoPremiacaoPropType),
  horsConcours: PropTypes.arrayOf(itemPremiacaoPropType),
  premiacao: PropTypes.arrayOf(itemPremiacaoPropType)
});

export const dadosPremiacaoPropType = PropTypes.shape({
  cidade: PropTypes.string.isRequired,
  ano: PropTypes.number,
  anosDisponiveis: PropTypes.arrayOf(PropTypes.string),
  historico: PropTypes.objectOf(historicoAnoPropType),
  regioes: PropTypes.arrayOf(regiaoPremiacaoPropType),
  horsConcours: PropTypes.arrayOf(itemPremiacaoPropType),
  premiacao: PropTypes.arrayOf(itemPremiacaoPropType)
});

export const cidadePremiacaoPropType = PropTypes.shape({
  nome: PropTypes.string.isRequired,
  pagina: PropTypes.string.isRequired,
  footer: PropTypes.shape({
    logoSmall: PropTypes.string,
    logoAlt: PropTypes.string,
    copyright: PropTypes.string
  }).isRequired
});
